import { Component, useContext, useEffect, useMemo, useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { RestAPI } from "@aws-amplify/api-rest";
import { withFormik, Form } from "formik";

import LoadingDialog from "../Utils/LoadingDialog";
import SelfHelp from "../Utils/SelfHelp";
import { callSend, FormRow, capitalize, VinculoNodo, VinculoEquipo, HeaderButtons, VinculoAguasArribaAguasAbajo } from "../Form/Form";
import { ZonesTable, ActuatorsOrSensorsTable, DownstreamUpstreamTable } from "../FarmInfo/Tables";

import { FertilizersTable } from "../Hydraulic/Tables";

import "react-toastify/dist/ReactToastify.css";
import { FarmContext } from "../../contexts/FarmContext";
import withName from "../../hoc/withName";

const hydraulic = "hydraulic_form";

const getHydra = (location) => {
    if (location.search.search("hydraulic") !== -1) {
        const params = new URLSearchParams(location && location.search);
        const hydra = params.get("hydraulic");
        return hydra;
    } else {
        return null;
    }
};

const getFarm = (location) => {
    const params = new URLSearchParams(location && location.search);
    const farm = params.get("farm");
    return farm;
};

const switchTipoHidraulica = (t, param, dontCap, es_monitoreo, tiene_controlador) => {
    let text = null;
    switch (param) {
        case 1:
            //return 'PUMP';
            text = t("farms.tipoHidraulica.pump");
            break;
        case 2:
            //return 'VALVE';
            text = es_monitoreo ? t("farms.tipoHidraulica.monitoringValve") : t("farms.tipoHidraulica.valve");
            break;
        case 3:
            //return 'WATER SOURCE';
            text = t("farms.tipoHidraulica.waterSource");
            break;
        case 4:
            //return 'TANK';
            text = t("farms.tipoHidraulica.tank");
            break;
        case 5:
            //return 'PH INJECTOR';
            text = t("farms.tipoHidraulica.phInjector");
            break;
        case 6:
            //return 'FERTILIZER INJECTOR';
            text = tiene_controlador ? t("farms.tipoHidraulica.fertiwise") : t("farms.tipoHidraulica.fertilizerInjector") ;
            break;
        case 9:
            //return 'WELL';
            text = t("farms.tipoHidraulica.well");
            break;
        case 14:
            //return 'VFD';
            text = t("farms.tipoHidraulica.vfd");
            break;
        case 16:
            //return 'BACKFLUSH STATION';
            text = t("farms.tipoHidraulica.bfStation");
            break;
        default:
            break;
    }
    if (!dontCap) text = text && capitalize(text);
    return text || "";
};

class HydraulicForm extends Component {
    render() {
    //const { resetForm, status = {}, canEdit, setStatus, data, t, handleSubmit } = this.props;
        const { resetForm, status = {}, canEdit, setStatus, data, t, i18n, handleSubmit, farmId, equipoRelacionado, nodoRelacionado, aguasAbajo, aguasArriba, tieneAgitador, units } = this.props;
        const thisUnits = units || {};
        if (!data) return <div className="card col-xl-12 col-lg-12 col-sm-12">No Data</div>;
        const isEdit = canEdit && status.edit;
        const selfHelpParams = {
            header: t("selfHelp.farmInfo.properties"),
            params: null,
            definitionName: [
                t("forms.upstream"),
                t("forms.downstream")
            ],
            definitionText: [
                t("selfHelp.definitions.upstream"),
                t("selfHelp.definitions.downstream")
            ]
        };
        return (
            <div className="card">
                <div className="card-body">
                    <Form id={hydraulic} onSubmit={handleSubmit}>
                        <div className='row'>
                            <div className='col col-sm-2 col-md-3 col-lg-4'>
                                <SelfHelp t={t} lng={i18n.language} params={selfHelpParams} onlyDict images={[]} />
                            </div>
                            <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                                <h5 className="card-title"><span>{t("farms.hydraulic.hidraInfo")}</span></h5>
                            </div>
                            <div className='col col-sm-2 col-md-3 col-lg-4 d-flex justify-content-end align-items-center'>
                                <HeaderButtons edit={status.edit} canEdit={canEdit} setStatus={setStatus} resetForm={resetForm} form={hydraulic} />
                            </div>
                        </div>
                        <div className='linea-titulo' />
                        <div className='row'>
                            <div className='col-12 text-center'>
                                <FormRow
                                    dato1={data.nombre}
                                    nombre1={t("general.name")}
                                    campo1="nombre"
                                    dato2={data.tipo === "" || data.tipo === null ? null : switchTipoHidraulica(t, data.tipo, null, data.es_monitoreo, data.tiene_controlador)}
                                    nombre2={t("general.type")}
                                    campo2="tipo"
                                />
                                <FormRow
                                    dato1={data.equipo_nombre}
                                    nombre1={t("forms.nombreEquipo")}
                                    campo1="equipo_nombre"
                                />

                                <FormRow
                                    dato1={data.equipo_nombre}
                                    nombre1={t("forms.nombreEquipo")}
                                    campo1="equipo_nombre"
                                />

                                <FormRow
                                    edit={isEdit}
                                    dato1={t("general.number_unit", { value: { number: data.caudal_teorico, unit: thisUnits.cteorico_ferti_unidad } })}
                                    nombre1={t("farms.zone.caudalTeorico")}
                                    campo1="caudal_teorico"
                                    type1="number"
                                />
                                {data.tipo === 4 &&
                  <FormRow
                      dato1={tieneAgitador ? t("general.answerYes") : t("general.answerNo")}
                      nombre1={t("forms.tieneAgitador")}
                      campo1="tiene_agitador"
                  />}

                                {data.delay_start && data.delay_stop &&
                  <FormRow
                      dato1={`${data.delay_start}s - ${data.delay_stop}s`}
                      nombre1={t("forms.delay")}
                      campo1="delay"
                  />}
                                <VinculoEquipo farmId={farmId} equipo_id={data.equipo_id} equipoRelacionado={equipoRelacionado} t={t} />
                                <VinculoNodo farmId={farmId} nodo_id={data.nodo_id} nodoRelacionado={nodoRelacionado} t={t} />

                                {aguasArriba.length <= 3 &&
                  <VinculoAguasArribaAguasAbajo farmId={farmId} hidraulicas={aguasArriba} t={t} aguasArriba />}

                                {aguasAbajo.length <= 3 &&
                  <VinculoAguasArribaAguasAbajo farmId={farmId} hidraulicas={aguasAbajo} t={t} />}

                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}

const FormikForm = withFormik({
    mapPropsToStatus: (props) => {
        return {
            edit: (props && props.edit) || false,
        };
    },
    mapPropsToValues: (props) => {
        const data = Object.assign({}, props.data);
        return data;
    },
    enableReinitialize: true,
    handleSubmit: (values, { props, ...actions }) => {
        props.updateData(values, props);
        actions.setStatus({ edit: false });
    }
})(withTranslation()(HydraulicForm));

const Hydraulic = ({ dataFarm }) => {
    const location = useLocation();
    const [_, dispatch] = useContext(FarmContext);
    const equiposDict = dispatch({ type: "get", path: "pumpsysDict" });
    const hidrasDict = dispatch({ type: "get", path: "hidrasDict" });
    const nodesDict = dispatch({ type: "get", path: "nodesDict" });
    const sectorsDict = dispatch({ type: "get", path: "sectorsDict" });
    const units = dispatch({ type: "get", path: "units" });
    const hydraId = getHydra(location);
    const farmId = getFarm(location);
    const { t, i18n } = useTranslation();
    const [info, setInfo] = useState({ data: null, isLoaded: false });
    const [sectorsInfo, setSectorsInfo] = useState(null);
    const [relacionados, setRelacionados] = useState({ sensores: [], actuadores: [] });
    const [aguasArribaAbajo, setAguasArribaAbajo] = useState({ arriba: [], abajo: [] });
    const [tieneAgitador, setTieneAgitador] = useState(false);
    const [canEdit, setCanEdit] = useState(false);
    const [tieneVariador, setTieneVariador] = useState(false);
    const [isPressure, setIsPressure] = useState(false);

    useEffect(() => {
        if (info && info.data !== null) {
            if (info.data.tipo === 6) {
                setCanEdit(true);
            } else {
                setCanEdit(false);
            }

            if (info.data.tipo === 1) {
                if (info.data.variador_frecuencia_id !== null) {
                    setTieneVariador(true);
                } else {
                    setTieneVariador(false);
                }
            } else {
                setTieneVariador(false);
            }
        }
    }, [info]);

    useEffect(() => {
        setInfo((state) => {
            return { ...state, isLoaded: false };
        });
        if (hydraId !== null) {
            const param = `/farms/${farmId}/hidraulica/${hydraId}`;

            const getDatos = async () => {
                RestAPI.get("apiAdminDropControl", param)
                    .then(res => JSON.parse(JSON.stringify(res)))
                    .then(([data]) => {
                        setInfo({ isLoaded: true, data });
                    })
                    .catch(err => console.error(err));
            };
            getDatos();
        }
    // this runs on initial hydraulic-page load, so only depends on the id
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hydraId]);

    const equipoRelacionado = useMemo(() => {
        if (equiposDict !== undefined && equiposDict !== null) {
            const equipo = info.data && equiposDict[info.data.equipo_id];
            return equipo && equipo.nombre;
        }
    }, [equiposDict, info]);

    const nodoRelacionado = useMemo(() => {
        if (nodesDict !== undefined && nodesDict !== null && nodesDict[info.data && info.data.nodo_id]) {
            const m13g = Object.values(nodesDict).find(n => n.tipo === 10) ? true : false;
            const nodo = nodesDict[info.data.nodo_id];
            const { nombre, parent } = nodo;
            return { nombre: nombre, parent: m13g ? parent : null };
        }
        return { nombre: null, parent: null };
    }, [nodesDict, info]);

    useEffect(() => {
        const arrSectoresRelacionados = [];
        setSectorsInfo(null);
        if (sectorsDict !== undefined && sectorsDict !== null && info.data) {
            if (info.data.tipo != 6) {
                const sectoresConHidraulica = Object.values(sectorsDict).filter(s => Array.isArray(s.hidraulicas) && s.hidraulicas.length > 0);
                Array.isArray(sectoresConHidraulica) && sectoresConHidraulica.forEach(sh => {
                    sh.hidraulicas.forEach(hidra => {
                        if (hidra == hydraId) {
                            if (info.data.tipo === 1 && info.data.grupos_variadores && info.data.grupos_variadores !== null) {
                                let hasGV = false;
                                if (sh.grupo_variador_id && (sh.porcentaje || sh.setpoint)) {
                                    hasGV = true;
                                } else {
                                    for (const gvs of info.data.grupos_variadores) {
                                        if (gvs.sector_id === sh.sector_id) {
                                            sh.grupo_variador_id = gvs.grupo_variador_id;
                                            sh.tipo_setpoint = gvs.tipo_setpoint;
                                            if(gvs.tipo_setpoint ==="PRESSURE") {
                                                setIsPressure(true);
                                                sh.setpoint = gvs.setpoint;
                                            }
                                            else if(gvs.tipo_setpoint ==="PERCENTAGE"){
                                                sh.porcentaje = gvs.porcentaje;
                                            }
                                            hasGV = true;
                                            break;
                                        }
                                    }
                                }
                                if (!hasGV) {
                                    sh.grupo_variador_id = null;
                                    sh.porcentaje = null;
                                    sh.setpoint = null;
                                }
                            }
                            if(tieneVariador && sh.tipo_setpoint){
                                arrSectoresRelacionados.push(sh);
                            }
                        }
                    });
                });
            } else {
                const sectoresConHidraulica = Object.values(sectorsDict).filter(s => Array.isArray(s.hidraulicas) && s.hidraulicas.length > 0); //array de sectores CON hidras
                Array.isArray(sectoresConHidraulica) && sectoresConHidraulica.forEach(sh => {
                    sh.hidraulicas.forEach(hidra => {
                        Array.isArray(aguasArriba) && aguasArriba.length > 0 &&
              aguasArriba.forEach(arriba => {
                  if (hidra == arriba.hidraulica_id) {
                      arrSectoresRelacionados.push(sh);
                  }
              });
                    });
                });
            }
            setSectorsInfo(arrSectoresRelacionados);
        }
    }, [sectorsDict, info, aguasArribaAbajo, tieneVariador]);

    useEffect(() => {
        const arrActuadoresRelacionados = [];
        const arrSensoresRelacionados = [];
        if (hidrasDict !== null && nodesDict !== null) {
            const hidraulicaActual = hidrasDict[hydraId];
            if (hidraulicaActual) {
                if (hidraulicaActual.actuadores !== null) {
                    hidraulicaActual.actuadores.forEach(act => {
                        const nodosConAct = Object.values(nodesDict).filter(n => Array.isArray(n.actuadores) && n.actuadores.length > 0);
                        Array.isArray(nodosConAct) && nodosConAct.forEach(n => {
                            n.actuadores.forEach(acts => {
                                acts.parentId = n.nodo_id;
                                if (acts.actuador_id === act.actuadorId) {
                                    arrActuadoresRelacionados.push(acts);
                                }
                            });
                        });
                    });
                }
                if (hidraulicaActual.sensores !== null) {
                    hidraulicaActual.sensores.forEach(sen => {
                        const nodosConAct = Object.values(nodesDict).filter(n => Array.isArray(n.sensores) && n.sensores.length > 0);
                        Array.isArray(nodosConAct) && nodosConAct.forEach(n => {
                            n.sensores.forEach(sens => {
                                sens.parentId = n.nodo_id;
                                if (sens.sensor_id === sen.sensorId) {
                                    arrSensoresRelacionados.push(sens);
                                }
                            });
                        });
                    });
                }
            }
        }
        setRelacionados({ sensores: arrSensoresRelacionados, actuadores: arrActuadoresRelacionados });
    }, [hidrasDict, nodesDict, info]);

    useEffect(() => {
        const arrPadresHidra = [];
        const arrHijosHidra = [];

        if (hidrasDict !== null && sectorsDict !== null) {
            Object.values(hidrasDict).forEach(h => {
                if (Array.isArray(h.hijos)) {
                    h.hijos.forEach(hh => {
                        if (hh == hydraId) {
                            arrPadresHidra.push(h);
                        }
                    });
                }
            });

            const sectoresConHidra = Object.values(sectorsDict).filter(s => Array.isArray(s.hidraulicas) && s.hidraulicas.length > 0);
            const hidraActual = hidrasDict[hydraId];

            Array.isArray(hidraActual && hidraActual.hijos) && hidraActual.hijos.length > 0 && hidraActual.hijos.forEach(hh => {
                hidrasDict[hh] && arrHijosHidra.push(hidrasDict[hh]);
            });
            sectoresConHidra.length > 0 && sectoresConHidra.forEach(sect => {
                sect.hidraulicas.forEach(sh => {
                    arrHijosHidra.length > 0 && arrHijosHidra.forEach(hijo => {
                        if (hijo.hidraulica_id === sh) {
                            hijo.parentId = sect.sector_id;
                        }
                        if (hijo.tipo) {
                            hijo.tipo_traducido = switchTipoHidraulica(t, hijo.tipo);
                        }
                    });

                    arrPadresHidra.length > 0 && arrPadresHidra.forEach(hijo => {
                        if (hijo.hidraulica_id === sh) {
                            hijo.parentId = sect.sector_id;
                        }

                        if (hijo.tipo) {
                            hijo.tipo_traducido = switchTipoHidraulica(t, hijo.tipo);
                        }
                    });
                });
            });
            setTieneAgitador(hidraActual && hidraActual.tiene_agitador);
            setAguasArribaAbajo({ arriba: arrPadresHidra, abajo: arrHijosHidra });
        }
    }, [farmId, hydraId, hidrasDict, sectorsDict, t]);

    const fertilizantes = useMemo(() => info.data && info.data.fertilizantes || [], [info, t]);

    const sensoresRelacionados = relacionados.sensores;
    const actuadoresRelacionados = relacionados.actuadores;
    const aguasArriba = aguasArribaAbajo.arriba;
    const aguasAbajo = aguasArribaAbajo.abajo;

    //tipo 6 => inyector de fertilizante

    const selfHelpImgAdd1 = import.meta.glob("../../img/autoayuda/*/autoayuda-fertiTable-add-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-fertiTable-add-1.png`];
    const selfHelpImgAdd2 = import.meta.glob("../../img/autoayuda/*/autoayuda-fertiTable-add-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-fertiTable-add-2.png`];
    const selfHelpImgAdd3 = import.meta.glob("../../img/autoayuda/*/autoayuda-fertiTable-add-3.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-fertiTable-add-3.png`];
    const selfHelpImgAdd4 = import.meta.glob("../../img/autoayuda/*/autoayuda-fertiTable-add-4.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-fertiTable-add-4.png`];
    const selfHelpImgAdd5 = import.meta.glob("../../img/autoayuda/*/autoayuda-fertiTable-add-5.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-fertiTable-add-5.png`];
    const selfHelpImgAdd6 = import.meta.glob("../../img/autoayuda/*/autoayuda-fertiTable-add-6.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-fertiTable-add-6.png`];

    const selfHelpImgEdit1 = import.meta.glob("../../img/autoayuda/*/autoayuda-fertiTable-edit-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-fertiTable-edit-1.png`];
    const selfHelpImgEdit2 = import.meta.glob("../../img/autoayuda/*/autoayuda-fertiTable-edit-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-fertiTable-edit-2.png`];
    const selfHelpImgEdit3 = import.meta.glob("../../img/autoayuda/*/autoayuda-fertiTable-edit-3.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-fertiTable-edit-3.png`];
    const selfHelpImgEdit4 = import.meta.glob("../../img/autoayuda/*/autoayuda-fertiTable-edit-4.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-fertiTable-edit-4.png`];
    const selfHelpImgEdit5 = import.meta.glob("../../img/autoayuda/*/autoayuda-fertiTable-edit-5.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-fertiTable-edit-5.png`];
    const selfHelpImgEdit6 = import.meta.glob("../../img/autoayuda/*/autoayuda-fertiTable-edit-6.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-fertiTable-edit-6.png`];
    const selfHelpImgEdit7 = import.meta.glob("../../img/autoayuda/*/autoayuda-fertiTable-edit-7.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-fertiTable-edit-7.png`];
    const selfHelpImgEdit8 = import.meta.glob("../../img/autoayuda/*/autoayuda-fertiTable-edit-8.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-fertiTable-edit-8.png`];

    const selfHelpImgDel1 = import.meta.glob("../../img/autoayuda/*/autoayuda-fertiTable-del-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-fertiTable-del-1.png`];
    const selfHelpImgDel2 = import.meta.glob("../../img/autoayuda/*/autoayuda-fertiTable-del-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-fertiTable-del-2.png`];
    const selfHelpImgDel3 = import.meta.glob("../../img/autoayuda/*/autoayuda-fertiTable-del-3.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-fertiTable-del-3.png`];

    const selfSucces = import.meta.glob("../../img/autoayuda/*/autoayuda-success.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-success.png`];
    const selfInfo = import.meta.glob("../../img/autoayuda/*/autoayuda-info.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-info.png`];
    const selfError = import.meta.glob("../../img/autoayuda/*/autoayuda-error.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-error.png`];

    const selfHelpParams = [
        {
            tab: 1, header: { text: t("selfHelp.fertiTable.instAdd") }, params:
        [
            { id: 1, text: t("selfHelp.fertiTable.msgAdd1"), image: selfHelpImgAdd1 },
            { id: 2, text: t("selfHelp.fertiTable.msgAdd2"), image: selfHelpImgAdd2 },
            { id: 3, text: t("selfHelp.fertiTable.msgAdd3"), image: selfHelpImgAdd3 },
            { id: 4, text: t("selfHelp.fertiTable.msgAdd4"), image: selfHelpImgAdd4 },
            { id: 5, text: t("selfHelp.fertiTable.msgAdd5"), image: selfHelpImgAdd5 },
            { id: 6, text: t("selfHelp.fertiTable.msgAdd6"), image: [selfSucces, selfInfo, selfError] },
            { id: 7, text: t("selfHelp.fertiTable.msgAdd7"), image: selfHelpImgAdd6 }
        ]
        },
        {
            tab: 2, header: { text: t("selfHelp.fertiTable.instEdit") }, params:
        [
            { id: 1, text: t("selfHelp.farmInfo.msg1"), image: selfHelpImgEdit1 },
            { id: 2, text: t("selfHelp.fertiTable.msgEdit2"), image: selfHelpImgEdit2 },
            { id: 3, text: t("selfHelp.fertiTable.msgEdit3"), image: selfHelpImgEdit3 },
            { id: 4, text: t("selfHelp.fertiTable.msgEdit4"), image: selfHelpImgEdit4 },
            { id: 5, text: t("selfHelp.fertiTable.msgEdit5"), image: selfHelpImgEdit5 },
            { id: 6, text: t("selfHelp.fertiTable.msgEdit6"), image: selfHelpImgEdit6 },
            { id: 7, text: t("selfHelp.fertiTable.msgAdd4"), image: selfHelpImgEdit7 },
            { id: 8, text: t("selfHelp.fertiTable.msgEdit8"), image: selfHelpImgEdit8 },
            { id: 9, text: t("selfHelp.fertiTable.msgAdd6"), image: [selfSucces, selfInfo, selfError] }
        ]
        },
        {
            tab: 3, header: { text: t("selfHelp.fertiTable.instDel") }, params:
        [
            { id: 1, text: t("selfHelp.fertiTable.msgDel1"), image: selfHelpImgDel1 },
            { id: 2, text: t("selfHelp.fertiTable.msgEdit5"), image: selfHelpImgDel2 },
            { id: 4, text: t("selfHelp.fertiTable.msgAdd6"), image: [selfSucces, selfInfo, selfError] },
            { id: 5, text: t("selfHelp.fertiTable.msgAdd7"), image: selfHelpImgDel3 },
        ]
        },
        {
            tab: 4, header: { text: t("selfHelp.properties") }, definition: true, params:
        [
            { id: 1, defName: "", defText: t("selfHelp.fertiTable.msgDefGeneral") },
            { id: 2, defName: `${t("forms.dilucion")}: `, defText: t("selfHelp.definitions.dilucion") }
        ],
        }
    ];

    const updateHidraulica = (data, newData) => {
        if (data.tipo === 6) {
            setInfo((state) => {
                return { ...state, isLoaded: false };
            });
            callSend(`/farms/${farmId}/inyector/${hydraId}`, data, newData, t, setInfo);
        } else {
            //callSend(`/farms/${farmId}/hidraulica/${hydraId}`, data, newData, t, setInfo)
        }
    };

    return (
        <div className='row-container'>
            {info.isLoaded === false && <LoadingDialog />}
            <div className='row'>
                <div className='col-12'>
                    <FormikForm
                        canEdit={canEdit}
                        farmId={farmId}
                        hydraId={hydraId}
                        data={info.data} isLoaded={info.isLoaded}
                        updateData={(newData) => updateHidraulica(info.data, newData)}
                        equipoRelacionado={equipoRelacionado}
                        nodoRelacionado={nodoRelacionado}
                        aguasAbajo={aguasAbajo}
                        aguasArriba={aguasArriba}
                        tieneAgitador={tieneAgitador}
                        units={units}
                        i18n={i18n}
                    />
                </div>

                {info.data && info.data.tipo === 4 && //ESTANQUE
          <div className="col-12">
              <div className="card">
                  <div className="card-body">
                      <div className='row'>
                          <div className='col col-sm-2 col-md-3 col-lg-4'>
                              {selfHelpParams &&
                      <SelfHelp t={t} lng={i18n.language} params={selfHelpParams} fertiTable />}
                          </div>
                          <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                              <h5 className="card-title">
                                  <span>{`${t("forms.fertilizantes")} (${fertilizantes.length})`}</span>
                              </h5>
                          </div>
                          <div id="fertiTableToolbar"
                              className='col col-sm-2 col-md-3 col-lg-4 d-flex justify-content-end align-items-center'
                          />
                      </div>
                      <div className='linea-titulo' />
                      {(fertilizantes.length > 0) ?
                          <FertilizersTable farmId={farmId} hydraId={hydraId} fertilizantes={fertilizantes} t={t} i18n={i18n} setInfo={setInfo} />
                          :
                          <span className='no-data'>{t("forms.noData")}</span>}
                  </div>
              </div>
          </div>}

                {aguasArriba.length > 3 &&
          <div className="col-12">
              <div className="card">
                  <div className="card-body">
                      <div className='row'>
                          <div className='col col-sm-2 col-md-3 col-lg-4' />
                          <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                              <h5 className="card-title">
                                  <span>{`${t("forms.upstream")} (${aguasArriba.length})`}</span>
                              </h5>
                          </div>
                          <div className='col col-sm-2 col-md-3 col-lg-4 d-flex justify-content-end align-items-center' />
                      </div>
                      <div className='linea-titulo' />
                      {(Array.isArray(aguasArriba) && aguasArriba.length > 0) ?
                          <DownstreamUpstreamTable farmId={farmId} hidraulicas={aguasArriba} dispatch={dispatch} t={t} i18n={i18n} />
                          :
                          <span className='no-data'>{t("forms.noData")}</span>}
                  </div>
              </div>
          </div>}

                {aguasAbajo.length > 3 &&
          <div className="col-12">
              <div className="card">
                  <div className="card-body">
                      <div className='row'>
                          <div className='col col-sm-2 col-md-3 col-lg-4' />
                          <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                              <h5 className="card-title">
                                  <span>{`${t("forms.downstream")} (${aguasAbajo.length})`}</span>
                              </h5>
                          </div>
                          <div className='col col-sm-2 col-md-3 col-lg-4 d-flex justify-content-end align-items-center' />
                      </div>
                      <div className='linea-titulo' />
                      {(Array.isArray(aguasAbajo) && aguasAbajo.length > 0) ?
                          <DownstreamUpstreamTable farmId={farmId} hidraulicas={aguasAbajo} dispatch={dispatch} t={t} i18n={i18n} />
                          :
                          <span className='no-data'>{t("forms.noData")}</span>}
                  </div>
              </div>
          </div>}

                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <div className='row'>
                                <div className='col col-sm-2 col-md-3 col-lg-4' />
                                <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                                    <h5 className="card-title">
                                        <span>{`${t("farms.zonesTable.title")} (${(Array.isArray(sectorsInfo) && sectorsInfo.length) || 0})`}</span>
                                    </h5>
                                </div>
                                <div id="zonesTableToolbar"
                                    className='col col-sm-2 col-md-3 col-lg-4 d-flex justify-content-end align-items-center'
                                />
                            </div>
                            <div className='linea-titulo' />

                            {(Array.isArray(sectorsInfo) && sectorsInfo.length > 0) ?
                                <ZonesTable dataFarm={dataFarm} dispatch={dispatch} canEdit={tieneVariador} isPressure={isPressure} sectorsInfo={sectorsInfo} equiposInfo={equiposDict} isHidra isPump={tieneVariador} hidraInfo={info.data} t={t} i18n={i18n} units={units} />
                                :
                                <span className='no-data'>{t("forms.noData")}</span>}
                        </div>
                    </div>
                </div>

                <div className="col-xl-6 col-lg-12 col-sm-12">
                    <div className="card">
                        <div className="card-body">
                            <div className='row'>
                                <div className='col col-sm-2 col-md-3 col-lg-4' />
                                <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                                    <h5 className="card-title">
                                        <span>{`${t("forms.actuadores")} (${actuadoresRelacionados.length})`}</span>
                                    </h5>
                                </div>
                                <div className='col col-sm-2 col-md-3 col-lg-4 d-flex justify-content-end align-items-center' />
                            </div>
                            <div className='linea-titulo' />
                            {(Array.isArray(actuadoresRelacionados) && actuadoresRelacionados.length > 0) ?
                                <ActuatorsOrSensorsTable farmId={farmId} actuadores={actuadoresRelacionados} dispatch={dispatch} t={t} i18n={i18n} />
                                :
                                <span className='no-data'>{t("forms.noData")}</span>}
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-12 col-sm-12">
                    <div className="card card-mr-0">
                        <div className="card-body">
                            <div className='row'>
                                <div className='col col-sm-2 col-md-3 col-lg-4' />
                                <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                                    <h5 className="card-title">
                                        <span>{`${t("node.sensores")} (${sensoresRelacionados.length})`}</span>
                                    </h5>
                                </div>
                                <div className='col col-sm-2 col-md-3 col-lg-4 d-flex justify-content-end align-items-center' />
                            </div>
                            <div className='linea-titulo' />
                            {(Array.isArray(sensoresRelacionados) && sensoresRelacionados.length > 0) ?
                                <ActuatorsOrSensorsTable farmId={farmId} actuadores={null} sensores={sensoresRelacionados} dispatch={dispatch} t={t} i18n={i18n} />
                                :
                                <span className='no-data'>{t("forms.noData")}</span>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export { switchTipoHidraulica };
export default withName(Hydraulic, "HydraFrag");
